import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M14 27.333c7.364 0 13.333-5.97 13.333-13.333S21.363.667 14 .667.667 6.637.667 14c0 2.133.5 4.149 1.391 5.937.237.475.315 1.018.178 1.53l-.794 2.969c-.345 1.288.834 2.467 2.123 2.122l2.968-.794a2.18 2.18 0 0 1 1.53.178A13.3 13.3 0 0 0 14 27.333M8.667 15.667a1 1 0 1 0 0 2H16a1 1 0 0 0 0-2zm-1-3.667a1 1 0 0 1 1-1h10.666a1 1 0 0 1 0 2H8.667a1 1 0 0 1-1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }